module.exports = __webpack_public_path__ + "static/media/group_26@3x.a6807b02.jpg";